/**
 * AppUpdateBanner — "er staat een nieuwe versie klaar", boven de pagina-inhoud.
 * Zichtbare tabs herladen nooit vanzelf; verborgen tabs doet app-version.ts.
 * Tijdens een gesprek is de knop uit, met de reden erbij.
 */
import { useEffect, useState } from 'react';
import { heeftLevendGesprek, reloadAlsVeilig, subscribeVersion, type VersionState } from '../../lib/app-version';
import { phoneState } from '../../lib/telephony';

export function AppUpdateBanner() {
  const [version, setVersion] = useState<VersionState | null>(null);
  const [inGesprek, setInGesprek] = useState(false);
  const [dismissedFor, setDismissedFor] = useState<string | null>(null);

  useEffect(() => subscribeVersion(setVersion), []);
  useEffect(() => phoneState.subscribe(() => setInGesprek(heeftLevendGesprek())), []);

  if (!version?.updateAvailable) return null;
  if (dismissedFor === version.served) return null;

  return (
    <div
      role="status"
      data-testid="app-update-banner"
      className="flex items-center gap-3 px-4 py-2 bg-indigo-50 border-b border-indigo-200 text-sm text-indigo-900"
    >
      <span className="flex-1">
        Er staat een nieuwe versie van de office-app klaar.
        {inGesprek ? ' Herladen kan zodra je gesprek klaar is.' : ' Herlaad om hem te gebruiken; de telefoon registreert dan opnieuw.'}
      </span>
      <button
        type="button"
        onClick={() => reloadAlsVeilig()}
        disabled={inGesprek}
        className="px-3 py-1 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Herladen
      </button>
      <button
        type="button"
        onClick={() => setDismissedFor(version.served)}
        className="text-indigo-700 hover:underline"
        aria-label="Melding sluiten"
      >
        Later
      </button>
    </div>
  );
}
